import ApiService from '../api.services';

const DashboardFinancialService = {
  month: async function () {
    try {
      const response = await ApiService.get('/api/dashboard/financial/month');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  billet: async function () {
    try {
      const response = await ApiService.get('/api/dashboard/financial/billet');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  profit: async function (months = 6) {
    try {
      const response = await ApiService.get(`/api/dashboard/financial/profit?months=${months}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  services: async function (month) {
    try {
      const response = await ApiService.get(`/api/dashboard/financial/services/${month}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  date: async function (month) {
    try {
      const response = await ApiService.get(`/api/dashboard/financial/date/${month}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default DashboardFinancialService;

export { DashboardFinancialService };

